import Vue from 'vue'
import Vuetify from 'vuetify'
import Vuelidate from 'vuelidate'
import 'vuetify/dist/vuetify.min.css'

import App from './App'
import i18n from './i18n'
import router from './router'
import store from './store/store'
import theme from './config/theme'

Vue.use(Vuetify, {
  theme,
  options: {
    customProperties: true,
  },
})

Vue.use(Vuelidate)

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
